import { getThreats } from "../root.selectors";
import { ThreatsMap } from "./threats.types";
import { RootState } from "../root.reducer";

export const getThreatsList = (state: RootState): ThreatsMap =>
  getThreats(state).list;
